import React, { useEffect, useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { update_profile, logout } from "../../redux/actions";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Cookies from "js-cookie";
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { Country, City } from "country-state-city";
import Select from 'react-select';

const Settings = (props) => {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails.user);

  const [image, setimage] = useState();
  const [previewImage, setPreviewImage] = useState();
  const [cropper, setcropper] = useState("");
  const [cropData, setcropData] = useState("");
  const [activeTab, setactiveTab] = useState("1");
  const [oldPassword, setoldPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [showPassword, setshowPassword] = useState(false);
  const [showPassword1, setshowPassword1] = useState(false);
  const [showPassword2, setshowPassword2] = useState(false);
  const [errors, seterrors] = useState({
    confirmPassword: false,
    newPassword: false,
    oldPassword: false,
  });
  const [imageFile, setImageFile] = useState();
  const [loading, setLoading] = useState();
  const [color, setColor] = useState("#ffffff");
  const [selectedCity, setSelectedCity] = useState();
  const [countryOptions] = useState(() => {
    const countries = Country.getAllCountries();
    let list = [];
    countries.forEach((country) => {
      const obj = {
        value: country.name.toLowerCase(),
        label: country.name,
        countryCode: country.isoCode,
      };
      list.push(obj);
    });
    return list;
  });
  const [cityOptions, setCityOptions] = useState();
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    postalcode: "",
  });

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  useEffect(() => {
    setPreviewImage(
      userDetails.image
        ? `${process.env.REACT_APP_SERVER_URL}/images/${userDetails.image}`
        : ""
    );
  }, []);

  useEffect(() => {
    setInitialValues({
      firstName:
        userDetails && userDetails.firstname ? userDetails.firstname : "",
      lastName: userDetails && userDetails.lastname ? userDetails.lastname : "",
      email: userDetails && userDetails.email ? userDetails.email : "",
      phone: userDetails && userDetails.mobile ? userDetails.mobile : "",
      address: userDetails && userDetails.address ? userDetails.address : "",
      city: userDetails && userDetails.city ? userDetails.city : "",
      country: userDetails && userDetails.country ? userDetails.country : "",
      postalcode: userDetails && userDetails.zipcode ? userDetails.zipcode : "",
    });
    if (userDetails?.country) {
      const cities = City.getCitiesOfCountry(
        countryOptions.find((option) => option.value === userDetails.country)
          .countryCode
      );
      console.log(cities)
      // alert('yes')
      let list = [];
      cities.forEach((city) => {
        const obj = { value: city.name.toLowerCase(), label: city.name };
        list.push(obj);
      });
      setCityOptions(list);
    }
  }, [userDetails]);

  useEffect(() => {
    if (cityOptions) {
      let currentOption = cityOptions.find(
        (option) => option.value === userDetails?.city
      );
      if (currentOption) {
        setSelectedCity(currentOption.value);
      }
    }
  }, [cityOptions]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setInitialValues({ ...initialValues, [name]: value });
  };

  const handleOnChangeCountry = (selectedOption) => {
    const cities = City.getCitiesOfCountry(selectedOption.countryCode);
    let list = [];
    cities.forEach((city) => {
      const obj = { value: city.name.toLowerCase(), label: city.name+'  ('+city.stateCode+')' };
      list.push(obj);
    });
    setInitialValues({ ...initialValues, country: selectedOption.value });
    setCityOptions(list);
  };

  const handleOnChangeCity = (selectedOption) => {
    setSelectedCity(selectedOption.value);
    setInitialValues({ ...initialValues, city: selectedOption.value });
  };

  //  const onHandleChange = ({ target: { name, value } }) => {
  //     seterrors({ ...errors,[name]: false,})
  //     // this.setState({errors: { ...errors,[name]: false,},     [name]: value,  });
  //   };

  const changePassword = async (request) => {
    try {
      console.log("In changePassword handler!!!");
      const response = await axios.request({
        data: {
          currentpassword: request.oldPassword,
          newpassword: request.newPassword,
          email: userDetails.email,
        },
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: Cookies.get("token"),
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/users/change-password`,
      });
      console.log("The response is: ", response);
      if (response.data.success === true) {
        toast.success(response.data.message);
        setTimeout(() => {
          // logout();
          dispatch(logout());
        }, 2000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  const updateProfile = async (request) => {
    try {
      request = { id: userDetails._id, ...request };
      //  alert(JSON.stringify(request))
      const response = await axios.request({
        data: request,
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: Cookies.get("token"),
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/users/update-profile`,
      });
      if (response.data.success) {
        toast.success(response.data.message);

        dispatch(update_profile(request));
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  const fileSelectHandler = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setimage(reader.result);
    };
    // setImageFile(files[0]);
    reader.readAsDataURL(files[0]);
  };

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      const img = cropper.getCroppedCanvas().toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        blob.name = "photo.jpeg"; //eslint-disable-line
        setcropData(blob);
        setimage("");
        // alert(cropper.getCroppedCanvas().toDataURL())
        // console.log(cropper.getCroppedCanvas().toDataURL())
        setPreviewImage(cropper.getCroppedCanvas().toDataURL());
        URL.revokeObjectURL(url);

        const reader = new FileReader();
        reader.onload = () => {
          // setimage(reader.result)
        };
        setImageFile(blob);
        reader.readAsDataURL(blob);

        // console.log(URL.revokeObjectURL(url))
      }, "image/jpeg");
    }
  };

  const removeImage = async () => {
    setPreviewImage("");
    setimage("");
    setImageFile();
    // const response = await axios.request({
    //   data: { image: previewImage },
    //   method: 'post',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': Cookies.get('token')
    //   },
    //   url: `${process.env.REACT_APP_SERVER_URL}/v1/users/remove-profile-photo`
    // })
    // if (response.data.success) {
    //   setPreviewImage(false);
    //   setimage("");
    // }
    // else
    //   toast.error("Unable to remove profile photo");

    // var r = confirm("Are you sure you want to delete?");
    // if(r){
    //   let pictureRef = await storage.refFromURL(profile_image);

    //   pictureRef.delete().then(async() => {
    //       let data = {
    //         firstName:user.firstName,
    //         lastName:user.lastName,
    //         email:user.email,
    //         phone:user.phone,
    //         address:user.address,
    //         city:user.city,
    //         country:user.country,
    //         postalcode:user.postalcode,
    //         profile_image:""
    //       }
    //       await updateProfile({data:data});
    //       getUserDetail();
    //   })
    // }
  };

  // componentDidMount(){
  //     this.getUserDetail();
  // }

  // useEffect(()=>{
  //   getUserDetail();
  // },[])

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "unset",
      outline: "none",
      border: state.isFocused ? "solid 1px #33bbfb" : "solid 1px #ffffff",
      boxShadow: "0 4px 10px -10px #000000",
      padding: 10,
      ":hover": { borderColor: "#ffffff" },
      cursor: "text",
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      padding: 0,
    }),
    input: (provided, state) => ({
      ...provided,
      padding: 0,
      margin: 0,
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: 0,
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      margin: 0,
    }),
  };

  return (
    <>
      <div className="dashboardCardRow">
        <div className="row border-radius-4 box  setting-mobile ">
          <div className=" col-lg-12 px-0" style={{ marginLeft: "0px" }}>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab == "1" ? "active" : ""}
                  onClick={() => setactiveTab("1")}
                >
                  Settings
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab == "2" ? "active" : ""}
                  onClick={() => setactiveTab("2")}
                >
                  Change Password
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              activeTab={activeTab}
              className="tab-content bg-white p-4 mt-4"
            >
              <TabPane tabId="1">
                <div
                  role="tabpanel"
                  className="tab-pane fade in active show"
                  id="Settings"
                >
                  <h2 className="dashheader-title mb-4">Account Settings</h2>
                  <div className="inner-form">
                    <div className="image-info d-flex py-4 ">
                      <div className="mr-5">
                        {!image ? (
                          <img
                            src={
                              previewImage
                                ? previewImage
                                : `${process.env.REACT_APP_URL}/static/images/profile-info.png`
                            }
                            alt=""
                          />
                        ) : null}
                        {image ? (
                          <Cropper
                            style={{ height: 195, width: "100%" }}
                            initialAspectRatio={1}
                            preview=".img-preview"
                            src={image}
                            viewMode={1}
                            guides={true}
                            minCropBoxHeight={10}
                            minCropBoxWidth={10}
                            background={false}
                            responsive={true}
                            autoCropArea={1}
                            checkOrientation={false}
                            onInitialized={(instance) => {
                              setcropper(instance);
                            }}
                          />
                        ) : null}
                      </div>
                      {image ? (
                        <div className="d-flex align-items-center">
                          {" "}
                          <button
                            onClick={() => {
                              getCropData();
                            }}
                            className="btn upload mr-4"
                          >
                            Crop
                          </button>
                          <button
                            onClick={() => {
                              setimage("");
                            }}
                            className="btn remove"
                          >
                            Cancel
                          </button>
                        </div>
                      ) : null}
                      {!image && !previewImage ? (
                        <div className="d-flex align-items-center">
                          {" "}
                          <button
                            onClick={() => {
                              document.getElementById("selectImage").click();
                            }}
                            className="btn upload mr-4"
                          >
                            Upload
                          </button>
                          <input
                            id="selectImage"
                            hidden
                            type="file"
                            onChange={(e) => {
                              fileSelectHandler(e);
                            }}
                          />
                        </div>
                      ) : null}
                      {previewImage ? (
                        <div className="d-flex align-items-center">
                          <button
                            onClick={() => {
                              removeImage();
                            }}
                            class="btn remove"
                          >
                            Remove
                          </button>
                        </div>
                      ) : null}
                    </div>
                    <hr />
                    <Formik
                      enableReinitialize={true}
                      initialValues={initialValues}
                      validationSchema={Yup.object({
                        firstName: Yup.string()
                          .required("First name is required")
                          .matches(
                            /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
                            "Please enter a valid first name."
                          ),

                        lastName: Yup.string()
                          .required("Last name is required")
                          .matches(
                            /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
                            "Please enter a valid last name."
                          ),

                        email: Yup.string()
                          .email("Invalid email address")
                          .required("Email is required"),

                        phone: Yup.string().matches(
                          /^([0-9\(\)\/\+\-]*)$/,
                          "Phone number is not valid, only number allowed"
                        ),

                        address: Yup.string().required("Address is required"),

                        city: Yup.string().required("City is required"),

                        country: Yup.string().required("Country is required"),

                        postalcode: Yup.string()
                          .required("Postal code is required")
                          .matches(/^\S+$/, "No spaces allowed"),
                      })}
                      onSubmit={async (values, { setSubmitting }) => {
                        setLoading(true);
                        if (imageFile) {
                          console.log("image file exists");
                          const fileData = new FormData();
                          fileData.append("image", imageFile);
                          const response = await axios.post(
                            `${process.env.REACT_APP_SERVER_URL}/v1/upload-photo`,
                            fileData,
                            {
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: Cookies.get("token"),
                              },
                            }
                          );
                          console.log("image name on submit: ", response.data);
                          values.image = response.data;
                        } else if (!previewImage) {
                          console.log("image is removed!");
                          values.image = ""
                        }
                        else {
                          values.image = userDetails?.image;
                          console.log("same image!");
                        }
                        console.log("form values: ", values);
                        setimage("");
                        setImageFile();
                        await updateProfile(values);
                        setSubmitting(false);
                        setLoading(false);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                      }) => (
                        <Form
                          onSubmit={handleSubmit}
                          id="email-edit"
                          className="mg-login mt-5"
                        >
                          <div className="row">
                            <div className="col-md-6 mb-4">
                              <label for="settingsFirstName">First name</label>
                              <input
                                value={values.firstName}
                                onChange={handleOnChange}
                                onBlur={handleBlur}
                                name="firstName"
                                type="text"
                                className="form-control"
                                id={"settingsFirstName"}
                                placeholder="Marcus"
                              />
                              {errors.firstName && touched.firstName && (
                                <p className="error text-danger">
                                  {errors.firstName}
                                </p>
                              )}
                            </div>
                            <div className="col-md-6 mb-4 ">
                              <label for="settingsLastName">Last name</label>
                              <input
                                value={values.lastName}
                                onChange={handleOnChange}
                                onBlur={handleBlur}
                                name="lastName"
                                type="text"
                                className="form-control"
                                id="settingsLastName"
                                placeholder="Atkins"
                              />
                              {errors.lastName && touched.lastName && (
                                <p className="error text-danger">
                                  {errors.lastName}
                                </p>
                              )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <label for="settingsEmail">email address</label>
                              <input
                                value={values.email}
                                name="email"
                                type="text"
                                disabled
                                className="form-control"
                                id="settingsEmail"
                                placeholder="test@domain.com"
                              />
                              {errors.email && touched.email && (
                                <p className="error text-danger">
                                  {errors.email}
                                </p>
                              )}
                            </div>
                            <div className="col-md-6 mb-4 ">
                              <label for="settingsPhone">phone number</label>
                              <input
                                value={values.phone}
                                onChange={handleOnChange}
                                onBlur={handleBlur}
                                name="phone"
                                type="text"
                                className="form-control"
                                id="settingsPhone"
                                placeholder="+13 6 12 34 56 78"
                              />
                              {errors.phone && touched.phone && (
                                <p className="error text-danger">
                                  {errors.phone}
                                </p>
                              )}
                            </div>
                            <div className="col-md-6 mb-4">
                              <label for="settingsAddess">address</label>
                              <input
                                value={values.address}
                                onChange={handleOnChange}
                                onBlur={handleBlur}
                                name="address"
                                type="text"
                                className="form-control"
                                id="settingsAddess"
                                placeholder="751 Green Hill Dr. Webster, NY 14580"
                              />
                              {errors.address && touched.address && (
                                <p className="error text-danger">
                                  {errors.address}
                                </p>
                              )}
                            </div>
                            <div className="col-md-6 mb-4 ">
                              {/* <label for="settingsCountry">country</label>
                              <select
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="country"
                                value={
                                  values.country
                                }
                                id="settingsCountry" className="form-control">
                                <option value="">Select Country</option>
                                <option value="United States">United States</option>
                              </select> */}
                              <label for="settingsCountry">country</label>
                              <Select id="color"
                            defaultValue={
                              countryOptions &&
                              countryOptions.find(
                                (option) =>
                                  option.value === userDetails?.country
                              )
                            }
                            onChange={handleOnChangeCountry}
                            classNamePrefix="ls-select"
                            options={countryOptions}
                        />
                              {/* <Select
                                styles={customSelectStyles}
                                name="country"
                                placeholder="Select Country"
                                onChange={handleOnChangeCountry}
                                options={countryOptions}
                                defaultValue={
                                  countryOptions &&
                                  countryOptions.find(
                                    (option) =>
                                      option.value === userDetails?.country
                                  )
                                }
                              /> */}
                              {errors.country && touched.country && (
                                <p className="error text-danger">
                                  {errors.country}
                                </p>
                              )}
                            </div>
                            <div className="col-md-6 mb-4">
                              {/* <label for="settingsCity">city</label>
                              <select
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="city"
                                value={
                                  values.city
                                } id="settingsCity" className="form-control">
                                <option value="">Select City</option>
                                <option value="Los Angeles">Los Angeles</option>
                              </select> */}
                              <label for="settingsCity">city</label>
                              <Select id="color"
                            onChange={handleOnChangeCity}
                            classNamePrefix="ls-select"
                            options={cityOptions}
                            value={
                              cityOptions &&
                              cityOptions.find(
                                (option) => option.value === selectedCity
                              )
                            }
                        />
                              {/* <Select
                                styles={customSelectStyles}
                                name="city"
                                placeholder="Select City"
                                onChange={handleOnChangeCity}
                                options={cityOptions}
                                value={
                                  cityOptions &&
                                  cityOptions.find(
                                    (option) => option.value === selectedCity
                                  )
                                }
                              /> */}
                              {errors.city && touched.city && (
                                <p className="error text-danger">
                                  {errors.city}
                                </p>
                              )}
                            </div>
                            <div className="col-md-6 mb-4 ">
                              <label for="settingsPostalCode">
                                postal code
                              </label>
                              <input
                                onChange={handleOnChange}
                                onBlur={handleBlur}
                                value={values.postalcode}
                                type="text"
                                name="postalcode"
                                className="form-control"
                                id="settingsPostalCode"
                                placeholder={10018}
                              />
                              {errors.postalcode && touched.postalcode && (
                                <p className="error text-danger">
                                  {errors.postalcode}
                                </p>
                              )}
                            </div>
                            <button
                              disabled={isSubmitting}
                              type="submit"
                              className="mx-3 sub-button mt-4"
                            >
                              {loading && (
                                <SyncLoader
                                  color={color}
                                  loading={loading}
                                  css={override}
                                  size={11}
                                />
                              )}
                              {!loading && "Save Changes"}
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div role="tabpanel" className="tab-pane " id="Change-Password">
                  <h2 className="dashheader-title mb-4">Password Settings</h2>
                  <Formik
                    initialValues={{
                      oldPassword: "",
                      newPassword: "",
                      confirmPassword: "",
                    }}
                    validationSchema={Yup.object({
                      oldPassword: Yup.string()
                        .required("Password is required")
                        .matches(
                          "^(?=.*[a-zA-Z0-9]).{6,}$",
                          "Please enter a valid password with 06-16 characters long and should be alphanumeric."
                        ),
                      newPassword: Yup.string()
                        .required("New password is required")
                        .matches(
                          /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{6,}$/,
                          "Password must be minimum 6 characters, at least one uppercase letter, one lowercase letter, one number and one special character"
                        ),
                      confirmPassword: Yup.string()
                        .required("Please confirm your password")
                        .matches(
                          /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{6,}$/,
                          "Password must be minimum 6 characters, at least one uppercase letter, one lowercase letter, one number and one special character"
                        )
                        .when("newPassword", {
                          is: (val) => (val && val.length > 0 ? true : false),
                          then: Yup.string().oneOf(
                            [Yup.ref("newPassword")],
                            "Password doesn't match"
                          ),
                        }),
                    })}
                    onSubmit={async (values, { setSubmitting }) => {
                      setLoading(true);
                      await changePassword(values);
                      setLoading(false);
                      setSubmitting(false);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <Form
                        onSubmit={handleSubmit}
                        id="email-edit"
                        className="mg-login mt-5"
                      >
                        <Row>
                          <div className="col-md-6 mb-4">
                            <FormGroup>
                              <Label htmlFor="oldPassword">
                                Current Password{" "}
                                <span className="astrik">*</span>
                              </Label>
                              <input
                                name="oldPassword"
                                className="form-control"
                                placeholder="Current password"
                                type={showPassword ? "type" : "password"}
                                value={values.oldPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <a
                                className="pwd-show"
                                onClick={() => setshowPassword(!showPassword)}
                                style={{ cursor: "pointer", top: "41px" }}
                              >
                                {showPassword ? "Hide" : "Show"}
                              </a>
                              {errors.oldPassword && touched.oldPassword && (
                                <p className="error text-danger">
                                  {errors.oldPassword}
                                </p>
                              )}
                            </FormGroup>
                          </div>
                          <div className="col-md-6 mb-4">
                            <Label htmlFor="newPassword">
                              New Password <span className="astrik">*</span>
                            </Label>
                            <input
                              name="newPassword"
                              className="form-control"
                              placeholder="New password"
                              type={showPassword1 ? "type" : "password"}
                              value={values.newPassword}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <a
                              className="pwd-show"
                              onClick={() => setshowPassword1(!showPassword1)}
                              style={{ cursor: "pointer", top: "41px" }}
                            >
                              {showPassword1 ? "Hide" : "Show"}
                            </a>
                            {errors.newPassword && touched.newPassword && (
                              <p className="error text-danger">
                                {errors.newPassword}
                              </p>
                            )}
                          </div>
                          <div className="col-md-6 mb-4">
                            <Label htmlFor="confirmPassword" className="email">
                              Confirm New Password{" "}
                              <span className="astrik">*</span>
                            </Label>
                            <input
                              name="confirmPassword"
                              className="form-control"
                              placeholder="Confirm New Password"
                              type={showPassword2 ? "type" : "password"}
                              value={values.confirmPassword}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <a
                              className="pwd-show"
                              onClick={() => setshowPassword2(!showPassword2)}
                              style={{ cursor: "pointer", top: "41px" }}
                            >
                              {showPassword2 ? "Hide" : "Show"}
                            </a>
                            {errors.confirmPassword &&
                              touched.confirmPassword && (
                                <p className="error text-danger">
                                  {errors.confirmPassword}
                                </p>
                              )}
                          </div>
                        </Row>
                        <button
                          disabled={isSubmitting}
                          className=" sub-button"
                          type="submit"
                        >
                          {loading && (
                            <SyncLoader
                              color={color}
                              loading={loading}
                              css={override}
                              size={11}
                            />
                          )}
                          {!loading && "Save Changes"}
                        </button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </TabPane>
            </TabContent>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
